import { useAuth } from '../contexts/AuthContext';

export function useActivityTracker() {
  const { token } = useAuth();

  const trackEvent = (
    event_type: string,
    symbol?: string,
    meta?: Record<string, unknown>,
  ) => {
    if (!token) return; // no-op when unauthenticated
    // Fire-and-forget — never blocks UI, errors silently ignored
    fetch('/api/v1/activity', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ event_type, symbol, meta }),
    }).catch(() => {});
  };

  return { trackEvent };
}
